
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { Runnit } from '@run-diffusion/shared';
import { ROUTER } from '@/router/constants';
import { RunnitsCRUDMixin, TeamUserMixin } from '@/mixins';
import RunnitTemplatesDashboard from './RunnitTemplatesDashboard/RunnitTemplatesDashboard.vue';
import RunnitManageAccessDialog from '@/views/Runnits/RunnitManageAccessDialog/RunnitManageAccessDialog.vue';
import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs.vue';

export default Vue.extend({
	name: 'RunnitTemplatesPage',
	metaInfo: {
		title: 'Runnit Templates',
	},
	mixins: [
		RunnitsCRUDMixin,
		TeamUserMixin,
	],
	data () {
		return {
			editRunnitAccessConfig: {
				open: false,
				runnits: [],
				onSuccess: () => {},
			},
		};
	},
	computed: {
		...mapState([
			'runnitState',
			'team',
		]),
		breadcrumbs () {
			return [
				{
					hoverColor: 'var(--primary-purple)',
					text: 'Boards',
					disabled: false,
					to: {
						name: ROUTER.RUNNIT_BOARDS_PAGE,
						query: this.$route.query,
					},
				},
				{
					hoverColor: 'var(--primary-blue)',
					text: 'Board Templates',
					disabled: true,
					to: {
						name: ROUTER.RUNNIT_BOARD_TEMPLATES_PAGE,
						query: this.$route.query,
					},
				},
			];
		},
	},
	methods: {
		...mapActions([
			'updateRunnitState',
		]),
		goBack () {
			// Go through breadcrumbs in reverse order to find the back route
			for (let i = this.breadcrumbs.length - 1; i >= 0; i--) {
				const breadcrumb = this.breadcrumbs[i];
				if (breadcrumb.to && !breadcrumb.disabled) {
					this.routerPush(this.$route, this.$router, breadcrumb.to);
					return;
				}
			}
		},
		onEditRunnit (runnit: Runnit) {
			this.onEditRunnitSettings(runnit);
		},
		onOpenRunnit (runnit: Runnit) {
			this.onOfferingCardClick(runnit.id, null);
		},
		onDeleteRunnit (runnit: Runnit) {
			this.updateRunnitState({
				runnitDeleteOpen: true,
				runnit: runnit,
			});
		},
		onEditRunnitAccess ({ runnits, onSuccess }) {
			this.editRunnitAccessConfig = {
				open: true,
				runnits,
				onSuccess: onSuccess || (() => {}),
			};
		},
	},
	components: {
		RunnitTemplatesDashboard,
		RunnitManageAccessDialog,
		BaseBreadcrumbs,
	},
});
